angular.module("Main").controller("KundenportalController", ["$rootScope", "$scope", "$q", "$window", "$document", "$timeout", "$state", "$stateParams", "$localStorage", "$uibModal", "BookingService", "DialogService", "SessionService",
    "AuthenticationService",
    function ($rootScope, $scope, $q, $window, $document, $timeout, $state, $stateParams, $localStorage, $uibModal, BookingService, DialogService, SessionService, AuthenticationService) {
        var vm = this;


        vm.loginWithPassword = true;
        vm.loginWithCode = false;
        vm.codeSend = false;

        vm.loginData = {};
        vm.loginData.email = '';
        vm.loginData.password = '';
        vm.isDetails = false;
        vm.isKontaktdaten = false;
        vm.isBankverbindung = false;
        vm.isVertraege = false;
        vm.isOnlineShop = false;
        vm.checkboxConfirmTermination = false;
        vm.isTerminateQuestion = false;
        vm.isTerminateConfirmation = false;
        vm.errorTermination = false;
        vm.badErrorTermination = false;
        vm.selectedContract = null;
        vm.checkboxConfirmRevoke = false;
        vm.isRevokeQuestion = false;
        vm.isRevokeConfirmation = false;
        vm.errorRevoke = false;
        vm.badErrorRevoke = false;
        vm.selectedRevokeContract = null;
        vm.statusKuendigung = null;
        vm.statusRevoke = null;
        vm.revokeTooLate = false;
        vm.revokeTooLateOS = false;

        vm.checkboxConfirmRevokeOS = false;
        vm.isRevokeQuestionOS = false;
        vm.isRevokeConfirmationOS = false;
        vm.errorRevokeOS = false;
        vm.badErrorRevokeOS = false;
        vm.selectedRevokeArticle = null;
        vm.statusRevokeOS = null;

        if (screen.width < 600) {
            vm.isMobilePhone = true;
        } else {
            vm.isMobilePhone = false;
        }

        checkLogin();

        BookingService.getVersions().then(function (versionData) {
            vm.centerComVersion = versionData.centercomVersion;
            if(vm.centerComVersion >= "6.88.0.0") {
                vm.isVersionRevoke = true;
            }
            if(vm.centerComVersion >= "6.89.0.0") {
                vm.isVersionRevokeOS = true;
            }
        });
        
        BookingService.getKPFeatureCodeLogin().then(function (data) {
            vm.loginCodeApi = data.isFeature;
        })

        function checkLogin() {
            vm.currentUser = $localStorage.user;
            vm.isLoggedInKundenportal = (!_.isNil(vm.currentUser) && vm.currentUser.memberNr);
            if (!_.isEmpty(vm.currentUser)) {
                vm.memberNr = vm.currentUser.memberNr;
                BookingService.loadMemberDetails(vm.currentUser.memberNr).then(function (data) {
                    vm.user = data;
                })
                vm.username = vm.currentUser.Firstname + " " + vm.currentUser.Lastname;
            }
        }

        var loginHandler = $rootScope.$on("loginKundenportal", function () {
            vm.isLoggedInKundenportal = true;
            vm.isLoggedIn = true;
            vm.username = $localStorage.user.username;
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData', 'shopData');
            vm.isLoggedIn = false;
            vm.isLoggedInKundenportal = false;
            vm.username = "";
            vm.loginData.email = '';
            vm.loginData.password = '';
            vm.loginWithPassword = true;
            vm.loginWithCode = false;
            vm.codeSend = false;
            vm.codeFalse = false;
            $state.go('customer', {cid: SessionService.getAuthData()});
        });

        getKursbuchungLayouKonfiguration();
        getCustomerName();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            })
        }

        function getCustomerName() {
            BookingService.getCustomerName().then(function (companyName) {
                vm.companyName = companyName;
            });
        }

        let checkLoginEmail = false;
        vm.checkEmailForLogin = function () {
            if (!checkLoginEmail) {
                checkLoginEmail = true;
                vm.dataLoading = true;
                vm.lockedEmail = false;
                vm.errorHeader = null;
                vm.miscError = false;
                BookingService.checkEmailForLogin(vm.loginData.email).then(function (data) {
                    vm.dataLoading = false;
                    vm.isDuplicate = false;

                    if (data.IsLocked) {
                        vm.dataLoading = false;
                        checkLoginEmail = false;
                        vm.lockedEmail = true;
                    } else if (data.uid && data.IsRegistered) {
                        vm.dataLoading = false;
                        vm.goToPassword = true;
                        checkLoginEmail = false;
                    } else if (!data.uid) {
                        vm.dataLoading = false;
                        vm.emailNotExists = true;
                        checkLoginEmail = false;
                    } else if (data.uid && !data.IsRegistered) {
                        let registration = {PersonNr: data.uid, email: vm.loginData.email};
                        vm.emailNotExists = false;
                        BookingService.createTemporaryMember(registration).then(function () {
                            vm.dataLoading = false;
                            vm.verifyWithCode = true;
                            checkLoginEmail = false;
                        }).catch(function () {
                            vm.dataLoading = false;
                            checkLoginEmail = false;
                            vm.miscError = true;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Bei_senden_der_Verifizierungsemail_ist_ein_Fehler_aufgetreten";
                        });
                    }
                }).catch(function (error) {
                    checkLoginEmail = false;
                    vm.dataLoading = false;

                    if (error.status === 409) {
                        vm.isDuplicate = true;
                        vm.goToPassword = false;
                        vm.emailNotExists = false;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Bitte_kontaktieren_Sie_Ihr_Studio";
                    } else {
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Bei_Überprüfung_der_Email_ist_ein Fehler_aufgetreten";
                    }
                })
            }
        };

        let checkCodeLogin = false;
        vm.checkCodeForLogin = function (code) {
            var data = {code: code, email: vm.loginData.email};
            if (!checkCodeLogin && vm.dataForm.code.$valid) {
                checkCodeLogin = true;
                vm.dataLoading = true;
                BookingService.checkRegisterCode(data).then(function (temporaryMember) {
                    if (temporaryMember.RightCode) {
                        vm.codeIsRight = true;
                        AuthenticationService.getNewPassword(temporaryMember.PersonNr).then(function () {
                            vm.newPasswordSend = true;
                            vm.goToPassword = true;
                            vm.infoText = "LT_Es_wurde_ein_neues_password_geschickt";
                            checkCodeLogin = false;
                            vm.dataLoading = false;
                        }).catch(function (err) {
                            vm.errorHeader = "T_Fehler";
                            //vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                            vm.errorText = "LT_Bei_senden_der_Email_mit_Password_ist_ein_Fehler_aufgetreten";
                            checkCodeLogin = false;
                            vm.dataLoading = false;
                        });
                    } else {
                        vm.codeIsRight = false;
                        checkCodeLogin = false;
                        vm.dataLoading = false;
                    }
                })
            }
        };

        vm.logout = function () {
            vm.username = "";
            $localStorage.user = {};
            $rootScope.$emit("logout");
            vm.isLoggedInKundenportal = false;
            vm.isLoggedIn = false;
            login = false;
            vm.isDetails = false;
            vm.isKontaktdaten = false;
            vm.isBankverbindung = false;
            vm.isVertraege = false;
            vm.loginData.email = null;
            vm.loginData.password = null;
            vm.memberNr = null;
            vm.user = null;
            vm.loginWithPassword = true;
            vm.loginWithCode = false;
            vm.codeSend = false;
            vm.codeFalse = false;
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData', 'shopData');
        };

        let login = false;
        vm.login = function (email, password) {
            if (!login) {
                login = true;
                vm.dataLoading = true;
                if (email !== '' && password !== '') {
                    AuthenticationService.login(email, password).then(function (response) {
                        if (response != null) {
                            let now = new Date;
                            let hours = 6;
                            //let minutes = 5;
                            //let ttl = minutes * 60 * 1000
                            let ttl = hours * 60 * 60 * 1000;
                            vm.isLoggedIn = true;
                            $localStorage.user = {};
                            $localStorage.user.username = response.Firstname + " " + response.Lastname;
                            $localStorage.user.Firstname = response.Firstname;
                            $localStorage.user.Lastname = response.Lastname;
                            $localStorage.user.isMember = response.IsMember;
                            $localStorage.user.memberNr = response.MemberNr;
                            $localStorage.user.Email = response.Email;
                            $localStorage.user.isPayPal = response.IsPaypal;
                            $localStorage.user.isBonitaet = response.IsBonitaet;
                            $localStorage.user.uid = response.uid;
                            $localStorage.user.expiryTime = now.getTime() + ttl;
                            vm.isLoggedInKundenportal = true;
                            vm.memberNr = response.MemberNr;
                            login = false;
                            $rootScope.$emit("loginKundenportal", vm.isLoggedIn);
                            checkLogin();
                            vm.dataLoading = false;
                        } else {
                            vm.wrongLoginData = true;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Falsche_Logindaten_KP";
                            login = false;
                            vm.dataLoading = false;
                        }
                    }).catch(function (err) {
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Beim_der_Prüfung_der_Email_und_Kennwort_ist_ein_Fehler_aufgetreten";
                        login = false;
                        vm.dataLoading = false;
                    });
                }
            }
        };

        vm.gotToKundendaten = function () {
            vm.isDetails = true;
            vm.isKontaktdaten = true;
        };

        vm.gotToBankverbindung = function () {
            vm.isDetails = true;
            vm.isBankverbindung = true;
        };

        vm.gotToVertraege = function () {
            vm.isDetails = true;
            vm.isVertraege = true;
            BookingService.loadMemberContracts(vm.currentUser.uid).then(function (data) {
                if (data.length > 0) {
                    vm.contracts = data;
                }

            });
        };

        vm.gotToOnlineShopArticles = function () {
            vm.isDetails = true;
            vm.isOnlineShop = true;
            vm.isVertraege = false;
            vm.isTerminateQuestion = false;
            vm.isTerminateConfirmation = false;
            vm.isRevokeConfirmation = false;
            vm.isRevokeQuestion = false;
            vm.selectedContract = null;
            vm.checkboxConfirmTermination = false;
            vm.isRevokeConfirmationOS = false;
            vm.isRevokeQuestionOS = false;
            vm.selectedArticle = null;
            vm.checkboxConfirmArticleRevoke = false;
            BookingService.loadMemberArticles(vm.currentUser.uid).then(function (data) {
                if (data.length > 0) {
                    vm.memberArticles = data;
                }

            });
        };

        vm.goToAppointments = function () {
            vm.isDetails = true;
            vm.isAppointments = true;
            BookingService.getMemberAppointments(vm.currentUser.uid).then(function (data) {
                vm.memberAppointments = data;
                _.forEach(vm.memberAppointments, function (appo) {
                    appo.Ressourcen = _.join(_.map(_.map(appo.Ressourcenplaner_JT_Termin_Ressources, 'Ressourcenplaner_Ressource'), 'Trainer'), " ,");
                    appo.Bezeichnung = appo.Typ.Terminart;
                    appo.Datum = moment(appo.Start).format('DD.MM.YYYY');
                    appo.Uhrzeit = moment(appo.Start).format("HH:mm") + " - " + moment(appo.Ende).format("HH:mm");

                })
            })
        };

        vm.openChangePassword = function () {
            //$uibModalInstance.close();
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/changePassword.html",
                controller: "ChangePasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.openForgotPassword = function () {
            // $uibModalInstance.close();
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/forgotPassword.html",
                controller: "ForgotPasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.registerModal = function () {
            SessionService.clear('globals');
            DialogService.openRegisterDialog().then(function (isLoggedIn) {
                if (isLoggedIn) {
                    vm.isLoggedInKundenportal = true;
                    vm.username = $localStorage.username;
                    $rootScope.$emit('loginKundenportal', vm.isLoggedInKundenportal)
                }
            }).catch(function (error) {
            });
            // let modalInstance = $uibModal.open({
            //     templateUrl: "app/Main/views/dialogs/registerShort.html",
            //     controller: "RegisterShortDialogController",
            //     controllerAs: "vm",
            //     backdrop: "static",
            //     windowClass: 'position-class',
            //     keyboard: false
            // });
            // return modalInstance.result;
        }

        vm.goBack = function () {
            vm.isDetails = false;
            vm.isKontaktdaten = false;
            vm.isBankverbindung = false;
            vm.isVertraege = false;
            vm.isAppointments = false;
            vm.isRevokeConfirmation = false;
            vm.isRevokeQuestion = false;
            vm.isOnlineShop = false;
            vm.isRevokeConfirmationOS = false;
            vm.isRevokeQuestionOS = false;
            vm.selectedArticle = null;
            vm.selectedRevokeArticle = null;
            vm.checkboxConfirmArticleRevoke = false;
        };

        vm.goBackToArticles = function () {
            vm.isDetails = true;
            vm.isVertraege = false;
            vm.isOnlineShop = true
            vm.isTerminateQuestion = false;
            vm.isTerminateConfirmation = false;
            vm.isRevokeConfirmation = false;
            vm.isRevokeQuestion = false;
            vm.selectedContract = null;
            vm.checkboxConfirmTermination = false;
            vm.isRevokeConfirmationOS = false;
            vm.isRevokeQuestionOS = false;
            vm.selectedArticle = null;
            vm.checkboxConfirmArticleRevoke = false;
            BookingService.loadMemberArticles(vm.currentUser.uid).then(function (data) {
                if (data.length > 0) {
                    vm.contracts = data;
                }

            });
        };

        vm.goBackToVertraege = function () {
            vm.isDetails = true;
            vm.isVertraege = true;
            vm.isTerminateQuestion = false;
            vm.isTerminateConfirmation = false;
            vm.isRevokeConfirmation = false;
            vm.isRevokeQuestion = false;
            vm.selectedContract = null;
            vm.checkboxConfirmTermination = false;
            vm.isRevokeConfirmationOS = false;
            vm.isRevokeQuestionOS = false;
            vm.selectedArticle = null;
            vm.checkboxConfirmArticleRevoke = false;
            vm.isOnlineShop = false;
            BookingService.loadMemberContracts(vm.currentUser.uid).then(function (data) {
                if (data.length > 0) {
                    vm.contracts = data;
                }

            });
        }

        vm.terminateContract = function (contract) {
            vm.isTerminateQuestion = true;
            vm.selectedContract = contract;
            vm.checkboxConfirmTermination = false;
            vm.selectedContract.Grund = '';
            vm.isVertraege = false;
            vm.selectedContract.EndDate = new Date(vm.selectedContract.TVE);
        };

        vm.confirmTerminateContract = function () {
            if (vm.checkboxConfirmTermination)
                BookingService.terminateContract(vm.selectedContract.VertragsNr, vm.currentUser.uid, vm.selectedContract.EndDate, vm.selectedContract.Grund).then(function (data) {
                    vm.isTerminateConfirmation = true;
                    vm.now = new Date();
                    vm.isTerminateQuestion = false;
                    vm.statusKuendigung = data.Status;
                    vm.selectedContract.Member = vm.user;
                    if (vm.user.Geschlecht === 'w') {
                        vm.selectedContract.Member.Anrede = 'Frau'
                    } else {
                        vm.selectedContract.Member.Anrede = 'Herr'
                    }
                    if (vm.selectedContract.EinheitLaufzeit === 'd') {
                        vm.selectedContract.EinheitLaufzeit = 0
                    }
                    if (vm.selectedContract.EinheitLaufzeit === 'w' || vm.selectedContract.EinheitLaufzeit === 'ww') {
                        vm.selectedContract.EinheitLaufzeit = 1
                    }
                    if (vm.selectedContract.EinheitLaufzeit === 'm') {
                        vm.selectedContract.EinheitLaufzeit = 2
                    }
                    if (vm.selectedContract.EinheitLaufzeit === 'y') {
                        vm.selectedContract.EinheitLaufzeit = 3
                    }
                    if (vm.selectedContract.EinheitVerlaengerung === 'd') {
                        vm.selectedContract.EinheitVerlaengerung = 0
                    }
                    if (vm.selectedContract.EinheitVerlaengerung === 'w' || vm.selectedContract.EinheitVerlaengerung === 'ww') {
                        vm.selectedContract.EinheitVerlaengerung = 1
                    }
                    if (vm.selectedContract.EinheitVerlaengerung === 'm') {
                        vm.selectedContract.EinheitVerlaengerung = 2
                    }
                    if (vm.selectedContract.EinheitVerlaengerung === 'y') {
                        vm.selectedContract.EinheitVerlaengerung = 3
                    }
                    if (vm.selectedContract.EinheitKuendigungsfrist === 'd') {
                        vm.selectedContract.EinheitKuendigungsfrist = 0
                    }
                    if (vm.selectedContract.EinheitKuendigungsfrist === 'w' || vm.selectedContract.EinheitKuendigungsfrist === 'ww') {
                        vm.selectedContract.EinheitKuendigungsfrist = 1
                    }
                    if (vm.selectedContract.EinheitKuendigungsfrist === 'm') {
                        vm.selectedContract.EinheitKuendigungsfrist = 2
                    }
                    if (vm.selectedContract.EinheitKuendigungsfrist === 'y') {
                        vm.selectedContract.EinheitKuendigungsfrist = 3
                    }
                    return BookingService.sendTerminateConfirmEmail(vm.selectedContract, vm.currentUser.uid, data.Status, vm.user.Geschlecht)
                    //catch error
                }).catch(function (error) {
                    if (error.status === 400) {
                        vm.errorTermination = true;
                    } else {
                        vm.badErrorTermination = true;
                    }
                })

        }

        vm.checkRevoke = function (date) {
            const abschlussDate = new Date(date);
            const now = new Date();
            const fourteenDaysAgo = new Date();
            fourteenDaysAgo.setDate(now.getDate() - 14);
            return abschlussDate >= fourteenDaysAgo;
        };

        vm.checkRevokeOS = function (date) {
            const abschlussDate = new Date(date);
            const now = new Date();
            const fourteenDaysAgo = new Date();
            fourteenDaysAgo.setDate(now.getDate() - 14);
            return abschlussDate >= fourteenDaysAgo;
        };

        vm.revokeContract = function (contract) {
            vm.isRevokeQuestion = true;
            vm.selectedRevokeContract = contract;
            vm.checkboxConfirmRevoke = false;
            vm.selectedRevokeContract.Grund = '';
            vm.isVertraege = false;
        };

        vm.revokeArticle = function (article) {
            vm.isRevokeQuestionOS = true;
            vm.selectedRevokeArticle = article;
            vm.checkboxConfirmRevokeOS = false;
            vm.selectedRevokeArticle.Grund = '';
            vm.isOnlineShop = false;
        };

        vm.confirmRevokeContract = function () {
            if (vm.checkboxConfirmRevoke)
                BookingService.revokeContract(vm.selectedRevokeContract.VertragsNr, vm.currentUser.uid, vm.selectedRevokeContract.Grund).then(function (data) {

                    // Vermerkt = 0,
                    // FristAbgelaufen = 1,
                    // Fehler = 2,
                    if (data.Status === 0) {
                        vm.isRevokeConfirmation = true;
                        vm.now = new Date();
                        vm.isRevokeQuestion = false;
                        vm.selectedRevokeContract.Member = vm.user;
                        if (vm.user.Geschlecht === 'w') {
                            vm.selectedRevokeContract.Member.Anrede = 'Frau'
                        } else {
                            vm.selectedRevokeContract.Member.Anrede = 'Herr'
                        }
                        // if(vm.selectedContract.EinheitLaufzeit === 'd') {
                        //     vm.selectedContract.EinheitLaufzeit = 0
                        // }
                        // if(vm.selectedContract.EinheitLaufzeit === 'w' || vm.selectedContract.EinheitLaufzeit === 'ww') {
                        //     vm.selectedContract.EinheitLaufzeit = 1
                        // }
                        // if(vm.selectedContract.EinheitLaufzeit === 'm') {
                        //     vm.selectedContract.EinheitLaufzeit = 2
                        // }
                        // if(vm.selectedContract.EinheitLaufzeit === 'y') {
                        //     vm.selectedContract.EinheitLaufzeit = 3
                        // }
                        // if(vm.selectedContract.EinheitVerlaengerung === 'd') {
                        //     vm.selectedContract.EinheitVerlaengerung = 0
                        // }
                        // if(vm.selectedContract.EinheitVerlaengerung === 'w' || vm.selectedContract.EinheitVerlaengerung === 'ww') {
                        //     vm.selectedContract.EinheitVerlaengerung = 1
                        // }
                        // if(vm.selectedContract.EinheitVerlaengerung === 'm') {
                        //     vm.selectedContract.EinheitVerlaengerung = 2
                        // }
                        // if(vm.selectedContract.EinheitVerlaengerung === 'y') {
                        //     vm.selectedContract.EinheitVerlaengerung = 3
                        // }
                        // if(vm.selectedContract.EinheitKuendigungsfrist === 'd') {
                        //     vm.selectedContract.EinheitKuendigungsfrist = 0
                        // }
                        // if(vm.selectedContract.EinheitKuendigungsfrist === 'w' || vm.selectedContract.EinheitKuendigungsfrist === 'ww') {
                        //     vm.selectedContract.EinheitKuendigungsfrist = 1
                        // }
                        // if(vm.selectedContract.EinheitKuendigungsfrist === 'm') {
                        //     vm.selectedContract.EinheitKuendigungsfrist = 2
                        // }
                        // if(vm.selectedContract.EinheitKuendigungsfrist === 'y') {
                        //     vm.selectedContract.EinheitKuendigungsfrist = 3
                        // }
                         return BookingService.sendRevokeConfirmEmail(vm.selectedRevokeContract, vm.currentUser.uid, data.Status, vm.user.Geschlecht)
                        //catch error
                    }
                    if (data.Status === 1) {
                        vm.revokeTooLate = true;
                    }
                    if (data.Status === 2) {
                        vm.errorRevoke = true;
                    }
                }).catch(function (error) {
                    if (error.status === 400) {
                        vm.errorRevoke = true;
                    } else {
                        vm.badErrorRevoke = true;
                    }
                })

        }

        vm.confirmRevokeArticle = function () {
            if (vm.checkboxConfirmArticleRevoke)
                BookingService.revokeArticle(vm.selectedRevokeArticle, vm.selectedRevokeArticle.Grund).then(function (data) {

                    // Vermerkt = 0,
                    // FristAbgelaufen = 1,
                    // Fehler = 2,
                    if (data.Status === 0) {
                        vm.isRevokeConfirmationOS = true;
                        vm.now = new Date();
                        vm.isRevokeQuestionOS = false;
                        vm.selectedRevokeArticle.Member = vm.user;
                        if (vm.user.Geschlecht === 'w') {
                            vm.selectedRevokeArticle.Member.Anrede = 'Frau'
                        } else {
                            vm.selectedRevokeArticle.Member.Anrede = 'Herr'
                        }
                      return BookingService.sendRevokeArticleConfirmEmail(vm.selectedRevokeArticle, vm.currentUser.uid, data.Status, vm.user.Geschlecht)
                        //catch error
                    }
                    if (data.Status === 1) {
                        vm.revokeTooLateOS = true;
                    }
                    if (data.Status === 2) {
                        vm.errorRevokeOS = true;
                    }
                }).catch(function (error) {
                    if (error.status === 400) {
                        vm.errorRevokeOS = true;
                    } else {
                        vm.badErrorRevokeOS = true;
                    }
                })

        };

        vm.loginPassword = function () {
            vm.loginWithPassword = true;
            vm.loginWithCode = false;
            vm.codeSend = false;
        };

        vm.loginCode = function () {
            vm.loginWithPassword = false;
            vm.loginWithCode = true;
        };

        let checkDataRunning = false;
        vm.dataLoading = false;
        vm.codeSend = false;
        vm.sendCode = function (email) {
            checkDataRunning = true;
            vm.dataLoading = true;
            let loginData = {email: email};
            return BookingService.createTemporaryMember(loginData).then(function () {
                checkDataRunning = false;
                vm.dataLoading = false;
                vm.codeSend = true;
                vm.errorText = "LT_Es_wurde_email_geschickt";
            }).catch(function () {
                checkDataRunning = false;
                vm.dataLoading = false;
                vm.errorHeader = "T_Fehler";
                vm.errorText = "LT_Bei_senden_der_Verifizierungsemail_ist_ein_Fehler_aufgetreten";
            })
        }

        let isRunning = false;
        vm.checkCode = function (email, code) {
           let checkData = {
                email: email, code:code
            };
            if (!isRunning && vm.loginData.code) {
                isRunning = true;
                vm.dataLoading = true;
                BookingService.checkLoginCode(checkData).then(function (response) {
                    vm.dataLoading = false;
                    vm.codeFalse = false;
                    vm.loginData.code = '';
                    vm.loginData.email = '';
                    if (response != null) {
                        let now = new Date;
                        let hours = 6;
                        //let minutes = 5;
                        //let ttl = minutes * 60 * 1000
                        let ttl = hours * 60 * 60 * 1000;
                        vm.isLoggedIn = true;
                        $localStorage.user = {};
                        $localStorage.user.username = response.Firstname + " " + response.Lastname;
                        $localStorage.user.Firstname = response.Firstname;
                        $localStorage.user.Lastname = response.Lastname;
                        $localStorage.user.isMember = response.IsMember;
                        $localStorage.user.memberNr = response.MemberNr;
                        $localStorage.user.Email = response.Email;
                        $localStorage.user.isPayPal = response.IsPaypal;
                        $localStorage.user.isBonitaet = response.IsBonitaet;
                        $localStorage.user.uid = response.uid;
                        $localStorage.user.expiryTime = now.getTime() + ttl;
                        vm.isLoggedInKundenportal = true;
                        vm.memberNr = response.MemberNr;
                        login = false;
                        $rootScope.$emit("loginKundenportal", vm.isLoggedIn);
                        checkLogin();
                        vm.dataLoading = false;
                    } else {
                        vm.wrongLoginData = true;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Falsche_Logindaten_KP";
                        login = false;
                        vm.dataLoading = false;
                    }
                }).catch(function (error) {
                    vm.dataLoading = false;
                    vm.codeFalse = true;
                    vm.dataLoading = false;
                    vm.errorHeader = "T_Fehler";
                    vm.errorText = "LT_Falscher_Code";
                    isRunning = false;
                })


            }
        }

    }]);